module.exports = __webpack_public_path__ + "media/sk_sk_s2_Ladislava.db1d87df.mp3";